<template>
  <div class="py-3 d-flex justify-space-between">
    <div>
      <v-icon class="mr-8" color="primary">{{ icon }}</v-icon>
      <span class="heading-5 primary--text font-weight-bold">{{ title }}</span>
      <div v-if="subTitle && !loading" class="ml-14">
        <span>{{ subTitle }}</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
